<template>

<div class="row">
    <div class="col">    
        <!--  Don't need all of this ...
        <div class="row">
            <div class="col">
                <tech-select 
                    label="Tech" 
                    v-model="model.UserId" 
                    placeholder="Choose the tech"
                ></tech-select>
            </div>
        </div>
        
        <div class="row mt-2">
            <div class="col">
                <div class="">Client</div>
                <client-ac 
                    label="Client" 
                    v-model="model.ClientId" 
                    inputclass="form-control"
                ></client-ac>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col">
                <job-select 
                    label="Job" 
                    :client="model.ClientId" 
                    v-model="model.RequestId"
                ></job-select>
            </div>
        </div>
        -->

        <div class="row mt-2">
            <div class="col">
                <kt-input 
                    type="datetime-local" 
                    label="Date" 
                    v-model="model.DateTaken"
                ></kt-input>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col">
                <kt-input 
                    type="textarea" 
                    label="Note" 
                    v-model="model.Note" 
                    placeholder="Enter your note"
                    rows="7"
                ></kt-input>
            </div>
        </div>

        <!-- don't need the attachment form 
        <div class="row mt-3">
            <div class="col">
                <attachment-form
                    class="border"
                    :request="model.RequestId"
                ></attachment-form>
            </div>
        </div>
        -->

    </div>
</div>

</template>

<script setup>

import { watch, onMounted } from "vue";
import TechSelect from "@/components/Techs/TechSelect.vue";
import ClientAc from "@/components/Clients/ClientAc.vue";
import JobSelect from "@/components/Jobs/JobSelect.vue";
import KtInput from "@/components/UI/KtInput.vue";
import AttachmentForm from "@/components/Attachments/AttachmentForm.vue";

const model = defineModel({
    type: Object,
    default: {}
});

// Set current date/time for new notes
onMounted(() => {
    if (!model.value.DateTaken) {
        // Format current date/time for datetime-local input (YYYY-MM-DDTHH:mm)
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        
        model.value.DateTaken = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
});

</script>